/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors } from '@blend/consumer-components';

export namespace DocSubheaderWrapper {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {}
}
export const docSubheaderHeight = 48;

const styles = StyleSheet.create({
  wrapper: {
    display: 'flex',
    width: '100%',
    backgroundColor: colors.catalystLight01,
    height: docSubheaderHeight,
  },
});

export const DocSubheaderWrapper: React.SFC<DocSubheaderWrapper.Props> = ({ children, ...htmlProps }) => {
  return (
    <div className={css(styles.wrapper)} {...htmlProps}>
      {children}
    </div>
  );
};
